import React, { Suspense } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import SEOMetaDetailsSection from "./SeoSettings";
import { SeoFormProvider } from "../Context/SeoFormContext";

const PageWithSEO: React.FC<{ title: string }> = ({ title }) => {
  const location = useLocation();

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">{title}</h1>
      <SEOMetaDetailsSection key={location.pathname} />
    </div>
  );
};

const SeoSettingsModule = () => {
  return (
    <SeoFormProvider>
      <div>
        <Suspense fallback={null}>
          <Routes>
            {/* Pages */}
            <Route
              path="pages/index-page"
              element={<PageWithSEO title="Index Page" />}
            />
            <Route path="pages/news" element={<PageWithSEO title="News" />} />
            <Route
              path="pages/articles"
              element={<PageWithSEO title="Articles" />}
            />
            <Route
              path="pages/interviews"
              element={<PageWithSEO title="Interviews" />}
            />
            <Route
              path="pages/reports"
              element={<PageWithSEO title="Reports" />}
            />
            <Route
              path="pages/events"
              element={<PageWithSEO title="Events" />}
            />
            <Route
              path="pages/white-papers"
              element={<PageWithSEO title="White Papers" />}
            />
            <Route
              path="pages/webinars"
              element={<PageWithSEO title="Webinars" />}
            />
            <Route
              path="pages/videos"
              element={<PageWithSEO title="Videos" />}
            />
            <Route
              path="pages/hospital-profiles"
              element={<PageWithSEO title="Hospital Profiles" />}
            />
            <Route
              path="pages/company-profiles"
              element={<PageWithSEO title="Company Profiles" />}
            />
            <Route
              path="pages/contact-us"
              element={<PageWithSEO title="Contact Us" />}
            />
            {/* Services */}
            <Route path="services/ivf" element={<PageWithSEO title="IVF" />} />
            <Route path="services/iui" element={<PageWithSEO title="IUI" />} />
            <Route
              path="services/icsi"
              element={<PageWithSEO title="ICSI" />}
            />
            <Route
              path="services/sperm-egg-freezing"
              element={<PageWithSEO title="Sperm/ Egg Freezing" />}
            />
            <Route
              path="services/surrogacy"
              element={<PageWithSEO title="Surrogacy" />}
            />{" "}
            <Route path="services/art" element={<PageWithSEO title="ART" />} />
          </Routes>
        </Suspense>
      </div>
    </SeoFormProvider>
  );
};

export default SeoSettingsModule;
